// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider } from "firebase/auth";
import { getFirestore } from "firebase/firestore";
import { getStorage } from "firebase/storage";
import { getFunctions } from "firebase/functions";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
// For Firebase JS SDK v7.20.0 and later, measurementId is optional
const firebaseConfig = {
  apiKey: process.env.REACT_APP_FIREBASE_API_KEY,
  authDomain: process.env.REACT_APP_FIREBASE_AUTH_DOMAIN,
  projectId: process.env.REACT_APP_FIREBASE_PROJECT_ID,
  storageBucket: process.env.REACT_APP_FIREBASE_STORAGE_BUCKET,
  messagingSenderId: process.env.REACT_APP_FIREBASE_MESSAGING_SENDER_ID,
  appId: process.env.REACT_APP_FIREBASE_APP_ID,
  measurementId: process.env.REACT_APP_FIREBASE_MEASUREMENT_ID,
};
const functionsRegion = process.env.REACT_APP_FIREBASE_FUNCTIONS_REGION || "europe-west3";
const isBrowser = typeof window !== "undefined";
const measurementId = firebaseConfig.measurementId;

// Initialize Firebase
const app = initializeApp(firebaseConfig);
const auth = getAuth(app);
const db = getFirestore(app);
const storage = getStorage(app);
const functions = getFunctions(app, functionsRegion);
const googleProvider = new GoogleAuthProvider();
googleProvider.setCustomParameters({ prompt: "select_account" });

let analyticsInstance = null;
let analyticsModule = null;
let analyticsConsentGranted = false;
let analyticsRequestVersion = 0;

function setGoogleAnalyticsDisabled(disabled) {
  if (isBrowser && measurementId) {
    window[`ga-disable-${measurementId}`] = disabled;
  }
}

function clearGoogleAnalyticsCookies() {
  if (!isBrowser) return;

  const analyticsCookieNames = document.cookie
    .split(';')
    .map((cookie) => cookie.trim().split('=')[0])
    .filter((name) => /^(_ga|_gid|_gat)(_|$)/.test(name));

  if (analyticsCookieNames.length === 0) return;

  const hostname = window.location.hostname;
  const hostnameParts = hostname.split('.');
  const domainCandidates = new Set(['']);

  if (hostname && hostname !== 'localhost') {
    domainCandidates.add(hostname);
    domainCandidates.add(`.${hostname}`);

    if (hostnameParts.length >= 2) {
      domainCandidates.add(`.${hostnameParts.slice(-2).join('.')}`);
    }
  }

  analyticsCookieNames.forEach((name) => {
    domainCandidates.forEach((domain) => {
      const domainAttribute = domain ? `; domain=${domain}` : '';
      document.cookie = `${name}=; Max-Age=0; path=/${domainAttribute}; SameSite=Lax`;
    });
  });
}

// Az Analytics SDK betöltése előtt is letiltjuk a Google Analytics adatküldését.
setGoogleAnalyticsDisabled(true);

export async function setAnalyticsConsent(granted) {
  analyticsConsentGranted = granted === true;
  analyticsRequestVersion += 1;
  const requestVersion = analyticsRequestVersion;

  setGoogleAnalyticsDisabled(!analyticsConsentGranted);

  if (!analyticsConsentGranted) {
    if (analyticsInstance && analyticsModule) {
      analyticsModule.setAnalyticsCollectionEnabled(analyticsInstance, false);
    }
    clearGoogleAnalyticsCookies();
    return null;
  }

  if (!isBrowser || !measurementId) return null;

  if (analyticsInstance && analyticsModule) {
    analyticsModule.setAnalyticsCollectionEnabled(analyticsInstance, true);
    return analyticsInstance;
  }

  const loadedAnalyticsModule = await import('firebase/analytics');
  const analyticsSupported = await loadedAnalyticsModule.isSupported();

  // A felhasználó a dinamikus import közben is visszavonhatja a hozzájárulását.
  if (
    !analyticsSupported ||
    !analyticsConsentGranted ||
    requestVersion !== analyticsRequestVersion
  ) {
    return null;
  }

  analyticsModule = loadedAnalyticsModule;
  analyticsInstance = loadedAnalyticsModule.getAnalytics(app);
  loadedAnalyticsModule.setAnalyticsCollectionEnabled(analyticsInstance, true);
  return analyticsInstance;
}

export { app, auth, googleProvider, db, storage, functions };
